module.exports.DropboxPluginId = '55a5d915446f517774210002';
module.exports.DropboxClaimedHosts = [
  'dropbox.com',
  'www.dropbox.com',
  'paper.dropbox.com',
];
